export default __webpack_public_path__ + "static/media/checkmark.ea909ad4.svg";